export const CATEGORY_ROLES = ["structure", "electrical", "mechanic", "finishing"];

// Roles of a user, tolerant of the legacy single `role` field.
export const rolesOf = (user) => {
  const r = user?.roles;
  if (Array.isArray(r) && r.length) return r;
  return user?.role ? [user.role] : [];
};

export const isAdmin = (user) => rolesOf(user).includes("super_admin");

// Category modules the user can act on (admin => all four).
export const userCategories = (user) =>
  isAdmin(user) ? CATEGORY_ROLES : rolesOf(user).filter((r) => CATEGORY_ROLES.includes(r));

export const visibleCategories = (user) => userCategories(user);

export const defaultCategory = (user) => {
  if (isAdmin(user)) return "structure";
  return userCategories(user)[0] || "structure";
};

// Whether the user must choose a section when submitting an estimation.
export const canSubmitMultiple = (user) => userCategories(user).length > 1;

export const canAccessCategory = (user, category) =>
  isAdmin(user) || userCategories(user).includes(category);

// Super Admin + Mechanic engineers may view / edit mechanic base prices.
export const canEditMechanicPrices = (user) =>
  isAdmin(user) || userCategories(user).includes("mechanic");

export const FACILITIES = [
  { key: "electrical", icon: "Zap", color: "#D97706" },
  { key: "mechanic", icon: "Wrench", color: "#059669" },
  { key: "structure", icon: "Building2", color: "#2563EB" },
  { key: "finishing", icon: "Paintbrush", color: "#7C3AED" },
];
